/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Switchtoinvestorportal3Inputs */

const en_btn_switchtoinvestorportal3 = /** @type {(inputs: Btn_Switchtoinvestorportal3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch to Client Experience Platform`)
};

/**
* | output |
* | --- |
* | "Switch to Client Experience Platform" |
*
* @param {Btn_Switchtoinvestorportal3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const btn_switchtoinvestorportal3 = /** @type {((inputs?: Btn_Switchtoinvestorportal3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Switchtoinvestorportal3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_btn_switchtoinvestorportal3(inputs)
});
export { btn_switchtoinvestorportal3 as "btn_switchToInvestorPortal" }